module.exports = __webpack_public_path__ + "img/avatar9_11zon.4dbec4b4.webp";